<template>
  <div>
    <tci-service-head :title="$t('service.service1.title')" :subtitle="$t('service.service1.subtitle')" :content="$t('service.service1.content')" :imgUrl='$i18n.locale=="zh"?require("../assets/service/s1-1.jpg"):require("../assets/service/s1-1-ja.jpg")'>
      <v-row>
        <v-card flat color="transparent" class="mx-auto my-12" :width='isMobile?"350":"700"' v-if="$t('service.service1.title2')">
          <v-card-title :class='isMobile?"title":"headline"+" mb-2"'>{{ $t('service.service1.title2') }}</v-card-title>
          <v-list>
            <div v-for="item in $t('service.service1.content2')" :key="item.title">
            <v-list-item :class='isMobile?"title":"subtitle-1"'>{{ item.title }}</v-list-item>
            <li class="body-1" style="font-size: 0.8rem !important" v-for="subItem in item.infos" :key="subItem">{{ subItem }}</li>
            </div>
          </v-list>
        </v-card>
      </v-row>
      <div v-if='$i18n.locale=="ja"' class="pa-4"></div>
      <v-row>
        <v-spacer></v-spacer>
        <v-img :max-width="isMobile?350:700" :src='$i18n.locale=="zh"?require("../assets/service/s1-2.jpg"):require("../assets/service/s1-2-ja.jpg")' ></v-img>
        <v-spacer></v-spacer>
    </v-row>
    <div v-if='$i18n.locale=="ja"' class="pa-4"></div>
    <v-row v-if='$i18n.locale=="ja"'>
        <v-spacer></v-spacer>
        <v-img :max-width="isMobile?350:700" src="../assets/service/s1-3-ja.jpg" ></v-img>
        <v-spacer></v-spacer>
    </v-row>
    </tci-service-head> 
    <tci-contact-footer color="white"></tci-contact-footer>
  </div>
</template>

<script>
import TciContactFooter from "@/components/TciContactFooter.vue";
import TciServiceHead from "@/components/TciServiceHead.vue";

export default {
  name: "CompanyService1",
  components: {
    "tci-contact-footer": TciContactFooter,
    "tci-service-head": TciServiceHead
  },
  data: () => ({
      isMobile:false
  }),
  mounted() {
    this.isMobile = this.$vuetify.breakpoint.xs;
  }
};
</script>
